import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { ResizeGroup } from '@fluentui/react';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { LayoutContext } from '@bingads-webui-react/app-layout-container';
import { SummaryBarItems, SummaryBarItemPropType } from './summary-bar-items';

export class SummaryBarItemsResizeGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    // Resize group naturally works when dragging the window size, but does not seem to work correctly for
    // larger window size changes. To work around this, we are using a Media query to detect a larger screen
    // change, and then using this resizeGroupKey to force ResizeGroup to update.
    this.state = {
      resizeGroupKey: 0,
    };
  }

  onReduceData = (currentData) => {
    const newOverflowIndex = this.getNextOverflow(currentData);
    if (newOverflowIndex === -1) {
      return undefined;
    }

    return {
      summaryBarItems: currentData.summaryBarItems,
      overflowIndex: newOverflowIndex,
    };
  };

  onGrowData = (currentData) => {
    const { overflowIndex, summaryBarItems } = currentData;
    if (overflowIndex === summaryBarItems.length) {
      return undefined;
    }

    let newOverflowIndex = _.findIndex(summaryBarItems.slice(overflowIndex + 1), item => !item.noOverflow);
    if (newOverflowIndex === -1) {
      newOverflowIndex = summaryBarItems.length; // Set to length so no items overflow
    } else {
      // Since we sliced, we need to add back the index
      newOverflowIndex += (overflowIndex + 1);
    }

    return {
      summaryBarItems: currentData.summaryBarItems,
      overflowIndex: newOverflowIndex,
    };
  };

  getNextOverflow = (data) => {
    const { summaryBarItems, overflowIndex } = data;
    return _.findLastIndex(summaryBarItems.slice(0, overflowIndex), item => !item.noOverflow);
  }

  getWindowWidth = () => {
    const body = document.getElementsByTagName('body')[0];
    return window.innerWidth || document.documentElement.clientWidth || body.clientWidth;
  }

  handleMediaChange = (matches) => {
    if (matches) {
      this.setState(state => ({ resizeGroupKey: state.resizeGroupKey + 1 }));
    }
  }

  render() {
    const { resizeGroupKey } = this.state;
    const {
      summaryBarItems, overflowAriaLabel, scope, siteMap,
    } = this.props;

    const startingData = {
      summaryBarItems,
      overflowIndex: summaryBarItems.length,
    };

    return (
      <div style={{ width: '100%' }}>
        {/* Use a media query to trigger an event when we see a large window size change.
            This will allow us to force ResizeGroup to update by changing the key */}
        <Media
          query={`(max-width: ${this.getWindowWidth() - 200}px)`}
          onChange={this.handleMediaChange}
        />

        <LayoutContext.Consumer>
          {layout => (
            <ResizeGroup
              key={`${resizeGroupKey}_${layout.config.menu.mode}`}
              data={startingData}
              onReduceData={this.onReduceData}
              onGrowData={this.onGrowData}
              onRenderData={data => (
                <SummaryBarItems
                  summaryBarItems={data.summaryBarItems}
                  overflowIndex={data.overflowIndex}
                  overflowAriaLabel={overflowAriaLabel}
                  scope={scope}
                  siteMap={siteMap}
                />
                )}
            />)}
        </LayoutContext.Consumer>

      </div>);
  }
}

SummaryBarItemsResizeGroup.propTypes = {
  overflowAriaLabel: PropTypes.string,
  summaryBarItems: PropTypes.arrayOf(SummaryBarItemPropType).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
};

SummaryBarItemsResizeGroup.defaultProps = {
  overflowAriaLabel: '',
};
